import React, { useEffect, useState } from 'react';
import { Card, Button, Image } from 'react-bootstrap';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
// import TableHeader from './produitsTableHeader';
import SubtleBadge from 'components/common/SubtleBadge';
// import classNames from 'classnames';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { Dropdown } from 'react-bootstrap';
// import CardDropdown from 'components/common/CardDropdown';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaRegFileLines } from 'react-icons/fa6';
import { RiFileEditLine } from 'react-icons/ri';
import { FiArchive } from 'react-icons/fi';
import { getProduits, getProduitsSite } from 'data/produitsPOS';
import { useNavigate } from 'react-router-dom';

// const data = [
//   {
//     id: '01',
//     produit: 'produit1',
//     categorie: 'Catégorie 1',
//     montantTtc: '120,000',
//     statut: 'Créé',
//     tva: 19
//   }
// ];

const ProduitsTable = () => {
  const [data, setData] = useState([]);
  const [dataSite, setDataSite] = useState([]);

  const columns = [
    {
      accessorKey: 'code',
      header: 'RÉFÉRENCE',
      meta: {
        headerProps: { className: 'pe-1 white-space-nowrap text-900' },
        cellProps: { className: 'font-sans-serif white-space-nowrap' },
      },
    },
    {
      accessorKey: 'produit',
      header: 'Produit',
      meta: {
        headerProps: { className: 'text-start text-900 ' },
        cellProps: {
          className: 'ps-5 text-end w-1 text-primary fw-semibold',
        },
      },
    },
    {
      accessorKey: 'punitttc',
      header: 'Prix avant remise',
      meta: {
        headerProps: { className: 'text-start text-900 ' },
        cellProps: {
          className: 'ps-2 text-end w-5 text-primary fw-semibold',
        },
      },
      cell: ({ row }) => {
        return <div className="text-end">{row.original.punitttc?.toFixed(3)}</div>;
      },
    },
    {
      accessorKey: 'remise',
      header: 'Remise',
      meta: {
        headerProps: { className: 'text-start text-900 ' },
        cellProps: {
          className: 'ps-2 text-end w-5 text-primary fw-semibold',
        },
      },
      cell: ({ row }) => {
        const { aepromo, rempromo } = row.original;
        return <div className="text-end">{aepromo == '1' ? `${rempromo}%` : '0%'}</div>;
      },
    },
    {
      accessorKey: 'prixFinal',
      header: 'Prix final',
      meta: {
        headerProps: { className: 'text-start text-900 ' },
        cellProps: {
          className: 'ps-2 text-end w-5 text-primary fw-semibold',
        },
      },
      cell: ({ row }) => {
        const { aepromo, rempromo } = row.original;
        return (
          <div className="text-end">
            {aepromo == '1'
              ? `${row.original.punitttc - (row.original.punitttc * rempromo) / 100}`
              : row.original.punitttc}
          </div>
        );
      },
    },
    {
      accessorKey: 'prix initial Site',
      header: 'Prix site',
      meta: {
        headerProps: { className: 'text-start text-900 ' },
        cellProps: {
          className: 'ps-2 text-end w-5 text-primary fw-semibold',
        },
      },
      cell: ({ row }) => {
        return <div className="text-end">{row.original.prixsite?.toFixed(3)}</div>;
      },
    },

    {
      accessorKey: 'prix final Site',
      header: 'Prix final site',
      meta: {
        headerProps: { className: 'text-start text-900 ' },
        cellProps: {
          className: 'ps-2 text-end w-5 text-primary fw-semibold',
        },
      },
    },
    {
      accessorKey: 'ecart',
      header: 'Ecart',
      meta: {
        headerProps: { className: 'text-start text-900 ' },
        cellProps: {
          className: 'ps-2 text-end w-5 text-primary fw-semibold',
        },
      },
    },
  ];

  useEffect(() => {
    const fetchProduits = async () => {
      try {
        const response = await getProduits();
        setData(response);
        console.log(response);
      } catch (error) {
        console.error('Error fetching produits:', error);
      }
    };
    const fetchProduitsSite = async () => {
      try {
        const response = await getProduitsSite();
        setDataSite(response);
        console.log(response);
      } catch (error) {
        console.error('Error fetching produits:', error);
      }
    };
    fetchProduits();
    fetchProduitsSite();
  }, []);

  const table = useAdvanceTable({
    data: data,
    columns: columns,
    selection: true,
    sortable: true,
    pagination: true,
    perPage: 100,
    selectionColumnWidth: 52,
  });

  const handleExport = () => {
    // Check if there's data to export
    if (!data || data.length === 0) {
      console.error('No data to export');
      return;
    }

    // Get headers from the first object's keys
    const headers = Object.keys(data[0]);

    // Create CSV header row
    let csvContent = headers.join(',') + '\n';

    // Add data rows
    data.forEach(item => {
      const row = headers.map(header => {
        // Escape quotes and wrap in quotes to handle commas in values
        const value = item[header] !== null ? item[header] : '';
        return `"${String(value).replace(/"/g, '""')}"`;
      });
      csvContent += row.join(',') + '\n';
    });

    // Create download link
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'produits.csv');
    link.style.visibility = 'hidden';

    // Trigger download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
  return (
    <>
      <div>
        <Button variant="primary" onClick={handleExport}>
          {' '}
          Exporter Excel
        </Button>
      </div>
      <div>
        <AdvanceTableProvider {...table}>
          <Card>
            <Card.Header className="px-0"></Card.Header>
            <Card.Body className="p-0" style={{ height: '500px', overflowY: 'auto' }}>
              <AdvanceTable
                headerClassName="bg-body-tertiary align-middle"
                rowClassName="btn-reveal-trigger align-middle"
                tableProps={{
                  size: 'sm',
                  className: 'fs-10 mb-0 overflow-hidden',
                }}
                // onRowClick={row => handleLignes(row)}
                fixedHeader={true}
              />
            </Card.Body>
            <Card.Footer>
              <AdvanceTableFooter rowInfo />
            </Card.Footer>
          </Card>
        </AdvanceTableProvider>
      </div>
    </>
  );
};

export default ProduitsTable;
